import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Grupo from "./Grupo";
import Lista from "./Lista";

const Index = ({ match }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
      <Route path={`${match.url}/lista`} component={Lista} />
      <Route path={`${match.url}/:id`} component={Grupo} />
    </Switch>
  </div>
);

export default Index;
